import { Controller } from "stimulus"
import { Modal } from "bootstrap"
import "tom-select/dist/css/tom-select.css"
import TomSelect from "tom-select"

export default class extends Controller {
  connect() {
    const controller = this;

    $(this.element).find(".tom-select").each(function() {
      const selectElement = this;
      const options = {
        plugins: ['remove_button'],
      }
      if(!selectElement.classList.contains("values-selector")){
        options["onChange"] = function(value) {
          controller.reRenderValuesSelector(selectElement);
        }
      }
      new TomSelect(selectElement, options);
    });
  }

  removeDemographicFilter(event) {
    event.preventDefault();
    event.target.closest('.demographic-filter').remove();
  }

  removeDemographicFilterAndRecalculate(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    event.target.closest('.demographic-filter').remove();
    this.reCalculateEmployees(event, form);
  }

  reRenderValuesSelector(target) {
    const answers = JSON.parse(target.closest('.demographic-filter').dataset.answersPool);
    const currentSelection = target.value;
    const valuesSelector = target.closest(".demographic-filter").querySelector(".values-selector");
    const control = valuesSelector.tomselect;
    control.clear();
    control.clearOptions();
    
    const currentOptions = answers[currentSelection] || [];
    currentOptions.forEach((option) => {
      control.addOption({ value: option, text: option });
    });
    control.refreshOptions(false);
    $(target.closest('.demographic-filter')).find('.select-all-container').removeClass("d-none");
  }

  selectAllValues(event) {
    const demographicFilter = event.target.closest('.demographic-filter');
    const valuesSelector = demographicFilter.querySelector(".values-selector");
  
    if (valuesSelector && valuesSelector.tomselect) {
      const tomSelectInstance = valuesSelector.tomselect;
  
      if (event.target.checked) {
        const allValues = Object.keys(tomSelectInstance.options);
        tomSelectInstance.setValue(allValues);
      } else {
        tomSelectInstance.clear();
      }
    }
    this.reCalculateEmployees(event);
  }

  reCalculateEmployees(event, formNode = null) {
    const url = event.target.closest('.demographic-filter').dataset.recalcEmployeesUrl;
    const form = formNode || event.target.closest('form');
    let serializedData = $(form).serialize();
    serializedData = serializedData.replace(/patch/, 'post');

    $.ajax({
      url: url,
      method: 'POST',
      data: serializedData,
      success: function(data) {
        document.getElementById('matching-employees-counter').textContent = `Matching Employees: ${data.count}`;
      }
    });
  }

  openModal(event) {
    event.preventDefault()

    this.modalElement = document.getElementById("demographicDetailsModal")
    this.modalTitleEl = document.getElementById("demographicDetailsModalLabel")
    this.modalBodyEl = this.modalElement.querySelector(".modal-body")

    this.bsModal = new Modal(this.modalElement)

    const fieldLabel = event.currentTarget.dataset.demographicModalLabel
    const rawDetails = event.currentTarget.dataset.demographicModalDetails

    let details = {}
    try {
      details = JSON.parse(rawDetails) || {}
    } catch (e) {
    }

    let bodyHtml = `
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Value</th>
            <th>Count</th>
          </tr>
        </thead>
        <tbody>
    `
    for (const [value, count] of Object.entries(details)) {
      bodyHtml += `
        <tr>
          <td>${value}</td>
          <td>${count}</td>
        </tr>
      `
    }
    bodyHtml += `</tbody></table>`

    this.modalTitleEl.textContent = fieldLabel
    this.modalBodyEl.innerHTML = bodyHtml

    this.bsModal.show()
  }

}
